import { useContext, useEffect } from 'react';
import { signOut, signInWithRedirect, getCurrentUser } from 'aws-amplify/auth';

import { StoreContext } from '../store';
import { SIGN_IN, SIGN_OUT } from '../constants/actions';
import { INACTIVE_TIME_ALLOWED } from '../constants/autologout';

import useDeadlineExpired from './useDeadlineExpired';

export const useSessionManagement = () => {
  const { dispatch } = useContext(StoreContext);

  const handleSignIn = () => {
    signInWithRedirect();
  };

  const handleSignOut = async () => {
    await signOut();
    dispatch({ type: SIGN_OUT });
  };

  return { signIn: handleSignIn, signOut: handleSignOut };
};

export const useSession = (lastActiveAt, dispatch) => {
  const inactive = useDeadlineExpired(lastActiveAt + INACTIVE_TIME_ALLOWED);

  useEffect(() => {
    let didCancel = false;
    // Prevent race condition:
    // If `inactive` changes while we're awaiting,
    // don't tell sign-in or sign-out to change state based on stale info.
    // https://overreacted.io/a-complete-guide-to-useeffect/#speaking-of-race-conditions

    const getSession = async () => {
      if (inactive) {
        dispatch({ type: SIGN_OUT });
        signOut();
      } else {
        try {
          const user = await getCurrentUser();

          if (! didCancel) {
            dispatch({ type: SIGN_IN, payload: { user } });
          }
        } catch {
          if (! didCancel) {
            // defensive sign out action trigger
            dispatch({ type: SIGN_OUT });
          }
        }
      }
    };

    getSession();

    return () => { didCancel = true; };
  }, [dispatch, inactive]);
};
